export default __webpack_public_path__ + "static/media/syncButton.9eb6299a.svg";